module.exports = __webpack_public_path__ + "img/Skokie.a6d6493c.png";